module.exports = {"pageTitleText":"Scroll管理","createText":"創建規則","groupName":"群組","scrollName":"Scroll名稱","status":"狀態","sections":{"essential":"基礎"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/scrolls.json
// module id = GMTs
// module chunks = 3